<template>
  <v-container fluid>
    <v-card class="pa-3">
      <v-card-title>
        Item dem Bundel Hinzufügen
      </v-card-title>
      <v-divider class="mb-3" />
      <v-form v-model="createForm.valid" @submit.prevent="">
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="createForm.item"
              :items="items"
              item-text="name"
              item-value="id"
              outlined
              :rules="[v => !!v || 'Item is required']"
              label="Item auswählen"
            />
          </v-col>
          <v-col class="py-0" cols="12" lg="4">
            <v-text-field
              v-model="createForm.min"
              type="number"
              outlined
              :rules="[v => !!v || 'Item is required']"
              label="Min"
            />
          </v-col>
          <v-col class="py-0" cols="12" lg="4">
            <v-text-field
              v-model="createForm.max"
              type="number"
              outlined
              :rules="[v => !!v || 'Item is required']"
              label="Max"
            />
          </v-col>
          <v-col class="py-0" cols="12" lg="4">
            <v-text-field
              v-model="createForm.default"
              type="number"
              outlined
              :rules="[v => !!v || 'Item is required']"
              label="Standard"
            />
          </v-col>
          <v-col class="d-flex pt-0 justify-end">
            <v-btn
              :disabled="!createForm.valid"
              type="button"
              color="primary"
              @click="add()"
            >
              Hinzufügen
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-list>
        <v-card>
          <v-list-item v-for="(item, i) in createdItems" :key="i">
            <v-row>
              <v-col>
                {{ getItemName(item.item) }}
              </v-col>
              <v-col> Max: {{ item.max }} </v-col>
              <v-col> Min: {{ item.min }} </v-col>
              <v-col> Standard: {{ item.default }} </v-col>
            </v-row>
          </v-list-item>
        </v-card>
      </v-list>
      <v-row>
        <v-col class="d-flex justify-end">
          <v-btn v-if="save" type="create" color="primary" @click="create()">
            Speichern
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
   name: 'BundleItemCreate',
   props: {
      items: {
         type: Object,
         required: true
      },
      bundle: {
         type: Number,
         required: true
      }
   },
   data () {
      return {
         createForm: {
            item: null,
            min: null,
            max: null,
            default: null,
            valid: false
         },
         save: false,
         createdItems: []
      }
   },
   methods: {
      create () {
         this.$inertia.post(
            this.route('bundle_item.store', this.bundle),
            this.createdItems
            , {
               onSuccess: () => this.$emit('updated')
            })
      },
      add () {
         this.createdItems.push({
            item: this.createForm.item,
            min: this.createForm.min,
            max: this.createForm.max,
            default: this.createForm.default
         })
         this.createForm.item = null
         this.createForm.min = null
         this.createForm.max = null
         this.createForm.default = null
         this.save = true
      },
      getItemName (item_id) {
         let name = ''
         this.items.every(element => {
            if (element.id === item_id) {
               name = element.name
               return false
            }
            return true
         })
         return name
      }
   }
}
</script>

<style></style>
